import { Icon } from "armstrong-react";
import React from "react";
import { connect } from "react-redux";
import { LinkButton } from "../../../../core/atoms/atoms";
import { CardContainer } from "../../../../shared/components/inspiration/cardContainer";
import { apiPromiseHook, createEnterHookPromise } from "../../../../shared/flux/actions/enterHooks";
import { CollectionKeyHelper } from "../../../../shared/helpers/contentCollectionHelpers";
import { MatchState } from "../../../../shared/helpers/reduxHelpers";
import ResponsiveContainer from "../../../../shared/helpers/responsiveContainer";
import { SwipeCarousel } from "../../../components/swipeCarousel/swipeCarousel";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import { ActionPromises } from "../../../state/actionPromises";

import "./reviewArchive.scss";

const stateToProps = (state: IWebStoreState) => ({
  locationState: state.country,
  content: state.contentByCollection,
});

type Props = ReturnType<typeof stateToProps>;

const ArchiveComponent = (props: Props) => {
  return MatchState(props.locationState, {
    data: location => {
      const locationReviewsKey = CollectionKeyHelper.LocationReviews(location.id);
      const reviewsState = props.content.data[locationReviewsKey];
      return (
        <div className="country-review-archive">
          {MatchState(reviewsState, {
            data: reviews => (
              <div className="cards-wrap width-wrapper">
                {reviews.length > 0 && (
                  <div>
                    <header>
                      <p><em>Showing all {reviews.length} reviews</em></p>
                    </header>

                    <ResponsiveContainer
                      mobile={() => (
                        <CardContainer
                          collectionKey={CollectionKeyHelper.LocationReviews(location.id)}
                          filters={{
                            locations: [location.id],
                            types: [ContentType.Review],
                          }}
                          renderCardWrapper={elements => (
                            <SwipeCarousel>
                              {elements}
                            </SwipeCarousel>
                          )}
                        />
                      )}
                      tablet={() => (
                        <CardContainer
                          collectionKey={CollectionKeyHelper.LocationReviews(location.id)}
                          filters={{
                            locations: [location.id],
                            types: [ContentType.Review],
                          }}
                          columnClassName="column is-4-tablet is-4-desktop is-3-widescreen is-3-fullhd"
                        />
                      )}
                    />
                  </div>
                )}

                {reviews.length === 0 && (
                  <div>
                    <h2>{location.name} reviews</h2>
                    <p>We don't have any reviews for {location.name} yet. Will you be the first?</p>
                    <LinkButton
                      to={WebRoutes.enquiryForm({ locationSlug: location.slug, campaign: "country-reviews" })}
                      icomoon={Icon.Icomoon.paperplane}
                      buttonClass="primary-button"
                      className="text--regular text--light"
                    >
                      Plan your trip
                      </LinkButton>
                  </div>
                )}
              </div>
            ),
          })}
        </div>
      );
    },
  }) as JSX.Element;
}

export const ReviewArchive = connect(stateToProps)(ArchiveComponent);

export const reviewArchiveOnEnter = apiPromiseHook(
  createEnterHookPromise((n) => ActionPromises.initialiseCountryReviewArchive(n.params.countrySlug)),
);
